<template>
  <div class="action-list-item">
    <div v-for="(item,index) in lists" :key="index" class="single-action-list-item flex">
      <div><i class="el-icon-remove-outline" @click="remove(index)" /></div>
      <div>
        <div class="flex">
          <div class="label">动作图片</div>
          <UploadImage :disabled="disabled" :url="item.image" :save-path="savePath" size-tips="480px*270px" @upload="uploader($event, index)" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label">动作顺序</div>
          <el-input v-model="item.order" :disabled="disabled" placeholder="请输入动作顺序" style="width:150px" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label">动作名称</div>
          <el-input v-model="item.name" :disabled="disabled" placeholder="请输入动作名称" style="width:150px;background: transparent;" />
        </div>
      </div>
      <div>
        <div class="flex">
          <div class="label">动作开始时间</div>
          <el-input v-model="item.actionPosition" :disabled="disabled" placeholder="示例：3:08" style="width:150px;background: transparent;" />
        </div>
      </div>
      <!-- <div>
        <div class="flex">
          <div class="label">动作持续时间</div>
          <el-input v-model="item.durationTime" placeholder="请输入动作持续时间" style="width:150px;background: transparent;" />
        </div>
      </div> -->
    </div>
    <div class="add-btns" @click="add"><i class="el-icon-plus">添加课程动作</i></div>
  </div>

</template>

<script>
import UploadImage from '@/components/UploadImage';

export default {
  name: 'ActionList',
  components: { UploadImage },
  props: {
    savePath: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lists: {
      type: Array,
      default: () => {
        return [
          // {
          //   image: '',
          //   order: 1,
          //   name: '',
          //   actionPosition: '',
          //   // durationTime: ''
          // }
        ];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    uploader(data, index) {
      this.lists[index].image = data;
      this.$emit('updateLists', this.lists);
    },
    add() {
      if (this.disabled) return;
      const index = this.lists.length + 1;
      this.lists.push({
        image: '',
        order: index,
        name: '',
        actionPosition: '',
        // durationTime: ''
      });
      this.$emit('updateLists', this.lists);
    },
    remove(index) {
      this.lists.splice(index, 1);
      this.$emit('updateLists', this.lists);
    },
  },
};
</script>

<style scoped lang="less">
.action-list-item {
  .single-action-list-item {
    background: #f7f7f7;
    padding: 30px;
    min-width: 1100px;
    flex-wrap: wrap;
    min-height: 280px;
    align-items: center;
    margin-top: 20px;

    .el-icon-remove-outline {
      font-size: 30px;
      color: #bbbbbb;
      line-height: 32px;
    }

    .flex {
      // height: 150px;
      align-items: center;
      margin-left: 30px;
      margin-bottom: 30px;
    }
    .label {
      margin-right: 10px;
    }
  }

  .add-btns {
    display: inline-block;
    border: 1px dashed #bbbbbb;
    color: #bbbbbb;
    padding: 0px 20px;
    margin-top: 20px;
    border-radius: 6px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.single-action-list-item {
  .el-input__inner {
    background: transparent;
  }
}
</style>
